import {type MouseEvent} from "react";
import {css, cx} from "@panda/css";

import {AiSparklesIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {AmplitudeButtonCategory, trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";

const PILL_LABEL = "Asystent AI";

interface IProps {
    onClick: () => void;
    buttonCategory: Extract<AmplitudeButtonCategory, "homepage" | "listing_page">;
    className?: string;
}

export const SemanticSearchAssistantPill = (props: IProps) => {
    const {onClick, buttonCategory, className} = props;

    // Search inputs open their autocomplete dropdown on wrapper click, the pill must not trigger it
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        trackAmplitudeButtonClick({buttonName: "rp_search_ai_assistant", buttonCategory, itemId: null, value: PILL_LABEL});
        onClick();
    };

    return (
        <button type="button" className={cx(pillStyle, className)} onClick={handleClick}>
            <AiSparklesIcon size="1.9" wrapperSize="1.9" wrapperColor="transparent" />
            <Text variant="info_txt_1" as="span" noWrap>
                {PILL_LABEL}
            </Text>
        </button>
    );
};

const pillStyle = css({
    display: "none",
    alignItems: "center",
    flex: "0 0 auto",
    gap: 0.5,
    height: "32px",
    px: 1,
    border: "1px solid var(--colors-secondary)",
    borderRadius: "0.8rem",
    background: "var(--colors-white)",
    color: "var(--colors-secondary)",
    cursor: "pointer",

    md: {
        display: "inline-flex"
    }
});
import {type MouseEvent} from "react";
import {css, cx} from "@panda/css";

import {AiSparklesIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {AmplitudeButtonCategory, trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";

const PILL_LABEL = "Asystent AI";

interface IProps {
    onClick: () => void;
    buttonCategory: Extract<AmplitudeButtonCategory, "homepage" | "listing_page">;
    className?: string;
}

export const SemanticSearchAssistantPill = (props: IProps) => {
    const {onClick, buttonCategory, className} = props;

    // Search inputs open their autocomplete dropdown on wrapper click, the pill must not trigger it
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        trackAmplitudeButtonClick({buttonName: "rp_search_ai_assistant", buttonCategory, itemId: null, value: PILL_LABEL});
        onClick();
    };

    return (
        <button type="button" className={cx(pillStyle, className)} onClick={handleClick}>
            <AiSparklesIcon size="1.9" wrapperSize="1.9" wrapperColor="transparent" />
            <Text variant="info_txt_1" as="span" noWrap>
                {PILL_LABEL}
            </Text>
        </button>
    );
};

const pillStyle = css({
    display: "none",
    alignItems: "center",
    flex: "0 0 auto",
    gap: 0.5,
    height: "32px",
    px: 1,
    border: "1px solid var(--colors-secondary)",
    borderRadius: "0.8rem",
    background: "var(--colors-white)",
    color: "var(--colors-secondary)",
    cursor: "pointer",

    md: {
        display: "inline-flex"
    }
});
